module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-4.1f6d7b53.png";